import getModuleRouters from './getModuleRouters';

export function getRouterData(app) {
  return getModuleRouters(app);
}
